/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Username_Check_ErrorInputs */

const en_onboarding_v1_username_check_error = /** @type {(inputs: Onboarding_V1_Username_Check_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please retry.`)
};

const de_onboarding_v1_username_check_error = /** @type {(inputs: Onboarding_V1_Username_Check_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwas ist schiefgegangen. Erneut versuchen.`)
};

const pt_br2_onboarding_v1_username_check_error = /** @type {(inputs: Onboarding_V1_Username_Check_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo deu errado. Tente novamente.`)
};

const tr_onboarding_v1_username_check_error = /** @type {(inputs: Onboarding_V1_Username_Check_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir sorun oluştu. Tekrar deneyin.`)
};

const zh_cn2_onboarding_v1_username_check_error = /** @type {(inputs: Onboarding_V1_Username_Check_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出了点问题。请重试。`)
};

const zh_hk2_onboarding_v1_username_check_error = /** @type {(inputs: Onboarding_V1_Username_Check_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發生錯誤。請重試。`)
};

const ko_kr2_onboarding_v1_username_check_error = /** @type {(inputs: Onboarding_V1_Username_Check_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문제가 발생했습니다. 다시 시도하세요.`)
};

const ru_ru2_onboarding_v1_username_check_error = /** @type {(inputs: Onboarding_V1_Username_Check_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что-то пошло не так. Повторите попытку.`)
};

const es_419_onboarding_v1_username_check_error = /** @type {(inputs: Onboarding_V1_Username_Check_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Something went wrong. Please retry." |
*
* @param {Onboarding_V1_Username_Check_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_username_check_error = /** @type {((inputs?: Onboarding_V1_Username_Check_ErrorInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Username_Check_ErrorInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_username_check_error(inputs)
	if (locale === "de") return de_onboarding_v1_username_check_error(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_username_check_error(inputs)
	if (locale === "tr") return tr_onboarding_v1_username_check_error(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_username_check_error(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_username_check_error(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_username_check_error(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_username_check_error(inputs)
	return es_419_onboarding_v1_username_check_error(inputs)
});